import React, { useEffect, useState } from "react";
import { Avatar, Button, Col, Input, Row, Select, Tabs, Tag, Alert } from "antd";
import { SearchOutlined, EditOutlined, PlusOutlined, ArrowLeftOutlined, LockOutlined, UserOutlined, MailOutlined, PhoneOutlined, FileTextOutlined, CheckCircleOutlined, ClockCircleOutlined, WarningOutlined, HourglassOutlined, CalendarOutlined } from "@ant-design/icons";
import ProfileImage from "../../assets/images/user.png";
import EditIcon from "../../assets/images/edit-pencil-icon.svg";
import CalendarPage from "../Auth/FullCalender";
import ClientPostTabs from "./PostTabs";
import ClientPreferenceModal from "./ClientPreferenceEditModal";
import CreateNewPostIndex from "./CreateNewPost";
import ManageContentTabs from "./ManageContentTabs";
import VaultTabs from "./VaultTabs";
import ReportsTabs from "./ReportsTabs";
import MonthlyReportTab from "./MonthlyReportTab";
import CollaborationTabs from "./CollaborationTabs";
import WritingAssistant from "./writingAssistant";
import { ShowToast, Severty } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import ClientBlogTabs from "./BlogTabs";
import ManageNotesTabs from "./NotesTabs";
import AssistantsTab from "./AssistantsTab";

// Live presence, derived server-side from lastActiveAt. Kept in step with the
// STATUS column on the client list so the two can't show different colours.
const PRESENCE_COLORS = {
  online: "green",
  away: "orange",
  busy: "red",
  offline: "default",
};

// Permission helper (robust to casing/extra spaces in names)
const getPermissionByName = (moduleName) => {
  try {
    const user = JSON.parse(localStorage.getItem("admin_userProfile") || "{}");
    if (user.type === "Admin") {
      return { view: true, add: true, edit: true, delete: true };
    }
    const normalizedTarget = String(moduleName || "").trim().toLowerCase();
    const permissions = user?.roleId?.permission || [];
    return (
      permissions.find(
        (p) => String(p?.name || "").trim().toLowerCase() === normalizedTarget
      ) || {}
    );
  } catch {
    return {};
  }
};

const { Option } = Select;
const { TabPane } = Tabs;

const ClientProfileView = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const defaultTab = queryParams.get("tab");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { request } = useRequest();
  const handleOpenModal = () => setIsModalOpen(true);
  const [refresh, setRefresh] = useState(0);
  const handleCloseModal = () => setIsModalOpen(false);
  const [clientData, setClientData] = useState();
  const [open, setOpen] = useState(false);
  const [profile, setProfile] = useState();
  const [cardData, setCardData] = useState();
  const handleOpenDrawer = () => setOpen(true);
  const handleCloseDrawer = () => setOpen(false);
  const { id } = useParams();
  const navigate = useNavigate();

  // Get permissions for each module
  const calendarPermission = getPermissionByName("Calendar");
  const postsPermission = getPermissionByName("Posts");
  const blogsPermission = getPermissionByName("blogs");
  const contentThemesPermission = getPermissionByName("Content Themes");
  const vaultPermission = getPermissionByName("Vault");
  const reportsPermission = getPermissionByName("Reports");
  const collaborationPermission = getPermissionByName("Collaboration");
  const writingAssistantPermission = getPermissionByName("Writing Assistant");
  const notesPermission = getPermissionByName("Notes");
  // Reuses the existing "customerManager" Role module (already governs
  // Client management elsewhere) rather than inventing a new one — see
  // backend-Imergey/src/routes/admin/CustomerAssistantRouter.ts.
  const customerManagerPermission = getPermissionByName("customerManager");

  const initialTab =
    defaultTab === "assistants" && customerManagerPermission?.view
      ? "11"
      : defaultTab === "posts" && postsPermission?.view
      ? "2"
      : defaultTab === "calendar" && calendarPermission?.view
        ? "1"
        : defaultTab === "blogs" && blogsPermission?.view
          ? "7"
          : defaultTab === "writing" && writingAssistantPermission?.view
            ? "8"
            : defaultTab === "notes" && notesPermission?.view
              ? "9"
              : calendarPermission?.view
                ? "1"
                : postsPermission?.view
                  ? "2"
                  : blogsPermission?.view
                    ? "7"
                    : contentThemesPermission?.view
                      ? "3"
                      : vaultPermission?.view
                        ? "4"
                        : reportsPermission?.view
                          ? "5"
                          : collaborationPermission?.view
                            ? "6"
                            : writingAssistantPermission?.view
                              ? "8"
                              : notesPermission?.view
                                ? "9"
                                : "1";

  const [activeTab, setActiveTab] = useState(location.state?.activeTab || initialTab);
  const [prefillWritingTopic, setPrefillWritingTopic] = useState("");
  const [prefillPostContent, setPrefillPostContent] = useState("");
  const [postDashboardView, setPostDashboardView] = useState("all");
  const [blogDashboardView, setBlogDashboardView] = useState("");

  const handleWrite = (topic) => {
    setPrefillWritingTopic(topic);
    setActiveTab("8");
  };

  const openPostsView = (view = "all") => {
    setPostDashboardView(view);
    setActiveTab("2");
  };

  const openBlogsView = (view = "") => {
    setBlogDashboardView(view);
    setActiveTab("7");
  };

  const openOverviewView = (view, posts, blogs) => {
    if (!posts && blogs) {
      openBlogsView(view === "all" ? "" : view);
      return;
    }
    openPostsView(view);
  };

  useEffect(() => {
    request({
      url: apiPath.getClients + `/${id}`,
      method: "GET",
      onSuccess: (data) => {
        if (data && data.data) {
          setProfile(data.data.clients);
          // setSelected(data.data);
        } else {
          console.error("Invalid response format:", data);
        }
      },
      onError: (error) => {
        console.error("Failed to fetch profile:", error);
      },
    });
  }, []);

  const getClientPrefernce = () => {
    request({
      url: "/admin/access-module/client-prefernce" + `/${id}`,
      method: "GET",
      onSuccess: (data) => {
        if (data && data.data) {
          setClientData(data.data.list);
        } else {
          //  ShowToast(data.message,Severty.ERROR)
        }
      },
      onError: (error) => {
        //  ShowToast(error,Severty.ERROR)
      },
    });
  };

  const getCardData = () => {
    request({
      url: "/admin/access-module/card-data" + `/${id}`,
      method: "GET",
      onSuccess: (data) => {
        if (data && data.data) {
          setCardData(data.data);
        } else {
          //  ShowToast(data.message,Severty.ERROR)
        }
      },
      onError: (error) => {
        //  ShowToast(error,Severty.ERROR)
      },
    });
  };

  useEffect(() => {
    getClientPrefernce();
    getCardData();
  }, [refresh]);

  const overviewCards = [
    {
      title: "Posts",
      view: "all",
      value: cardData?.totalContent ?? ((cardData?.totalPosts || 0) + (cardData?.blogCount || 0)),
      posts: cardData?.totalPosts || 0,
      blogs: cardData?.totalBlogs ?? cardData?.blogCount ?? 0,
      icon: <FileTextOutlined />,
      iconColor: "#3b6b94",
    },
    {
      title: "Published",
      view: "published",
      value: cardData?.published || 0,
      posts: cardData?.publishedPosts || 0,
      blogs: cardData?.publishedBlogs || 0,
      icon: <CheckCircleOutlined />,
      iconColor: "#52c41a",
    },
    {
      title: "In-Review",
      view: "in-review",
      value: cardData?.inReview || 0,
      posts: cardData?.inReviewPosts || 0,
      blogs: cardData?.inReviewBlogs || 0,
      icon: <ClockCircleOutlined />,
      iconColor: "#fa8c16",
    },
    {
      title: "Delayed",
      view: "delayed",
      value: cardData?.delayed || 0,
      posts: cardData?.delayedPosts || 0,
      blogs: cardData?.delayedBlogs || 0,
      icon: <WarningOutlined />,
      iconColor: "#ff4d4f",
    },
    {
      title: "Pending Post",
      view: "pending",
      value: cardData?.pending || 0,
      posts: cardData?.pendingPosts || 0,
      blogs: cardData?.pendingBlogs || 0,
      icon: <HourglassOutlined />,
      iconColor: "#722ed1",
    },
    {
      title: "Upcoming Post",
      view: "upcoming",
      // Posts locked in to auto-publish (action="publish") for a future
      // date — not just anything with a future selectedDate, which used to
      // also sweep in drafts/approved posts still awaiting action.
      value: cardData?.schedulePost || 0,
      posts: cardData?.schedulePost || 0,
      blogs: 0,
      icon: <CalendarOutlined />,
      iconColor: "#1890ff",
    },
  ];

  return (
    <>
      <div className="client-profile-view-page">
        <Button
          className="back-btn"
          type="default"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)} // goes back one page
          style={{ marginBottom: 16 }}
        >
          Back
        </Button>

        <div className="client-profile-header mb-2">
          <div className="client-profile-img-outer">
            <div className="view-client-img">
              <img src={profile?.image || ProfileImage} />
            </div>
            <div className="view-client-text">
              <h6>
                {profile?.name}{" "}
                <Tag color={PRESENCE_COLORS[profile?.currentStatus] || PRESENCE_COLORS.offline}>
                  {profile?.currentStatus
                    ? profile.currentStatus.charAt(0).toUpperCase() + profile.currentStatus.slice(1)
                    : "Offline"}
                </Tag>
              </h6>
              <p>
                Last Interaction Date :{" "}
                <strong>
                  {moment(profile?.updated_at || new Date()).format(
                    "YYYY-MM-DD"
                  )}
                </strong>{" "}
              </p>
            </div>
          </div>
        </div>
        <div className="acc-stats-wrapper">
          {/* ── Stats cards — all 4 in one row ── */}
          <div className="acc-client-outer-list">
            {overviewCards.map((card) => (
              <div
                key={card.view}
                className="acc-card-main"
                onClick={() => openOverviewView(card.view, card.posts, card.blogs)}
                style={{ cursor: "pointer" }}
              >
                <div className="acc-card-text">
                  <h6>{card.title}</h6>
                  <h4>{card.value || 0}</h4>
                  <div className="acc-card-breakdown">
                    <span
                      role="button"
                      tabIndex={card.posts ? 0 : -1}
                      className={card.posts ? "" : "acc-card-breakdown-disabled"}
                      onClick={(event) => {
                        event.stopPropagation();
                        if (card.posts) openPostsView(card.view);
                      }}
                    >
                      Posts: {card.posts || 0}
                    </span>
                    <span> | </span>
                    <span
                      role="button"
                      tabIndex={card.blogs ? 0 : -1}
                      className={card.blogs ? "" : "acc-card-breakdown-disabled"}
                      onClick={(event) => {
                        event.stopPropagation();
                        if (card.blogs) openBlogsView(card.view === "all" ? "" : card.view);
                      }}
                    >
                      Blogs: {card.blogs || 0}
                    </span>
                  </div>
                </div>
                <div className="acc-card-icon" style={{ color: card.iconColor }}>
                  {card.icon}
                </div>
              </div>
            ))}
          </div>

          {/* ── Account Manager professional bar ── */}
          {profile?.brandManager?.[0] && (() => {
            const manager = profile.brandManager[0];
            const phone =
              manager.countryCode && manager.mobileNumber
                ? `${manager.countryCode} ${manager.mobileNumber}`
                : null;
            return (
              <div className="acc-manager-bar">
                <div className="acc-manager-bar-left">
                  <span className="acc-manager-icon-wrap">
                    <UserOutlined />
                  </span>
                  <div className="acc-manager-info">
                    <span className="acc-manager-label">Account Manager</span>
                    <strong className="acc-manager-name">{manager.name}</strong>
                  </div>
                </div>
                <div className="acc-manager-bar-right">
                  {manager.email && (
                    <span className="acc-manager-chip">
                      <MailOutlined />
                      {manager.email}
                    </span>
                  )}
                  {phone && (
                    <span className="acc-manager-chip">
                      <PhoneOutlined />
                      {phone}
                    </span>
                  )}
                </div>
              </div>
            );
          })()}
        </div>
      </div>
      <div className="client-profile-view-page mt-3">
        <div className="preferences-card-header">
          <h6>Client Preferences Panel</h6>
          {(postsPermission?.edit || calendarPermission?.edit || blogsPermission?.edit) && (
            <Button className="edit-icon-btn" onClick={handleOpenModal}>
              <img src={EditIcon} />
            </Button>
          )}
        </div>
        <div className="preferences-card-list">
          <div className="preferences-card-list-menubar">
            <h6>Industry</h6>
            <ul>
              {clientData?.industry?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="preferences-card-list-menubar">
            <h6>Target Audience</h6>
            <ul>
              {clientData?.audience?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="preferences-card-list-menubar">
            <h6>Geography</h6>
            <ul>
              {clientData?.geography?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="preferences-card-list-menubar">
            <h6>Posting Schedule</h6>
            <ul>
              {clientData?.schedule?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="acces-client-calender">
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          className="client-tabs"
        >
          {calendarPermission?.view && (
            <TabPane tab={<span className="tab-label">📆 Calendar</span>} key="1">
              <div className="tab-content">
                <CalendarPage
                  user={profile}
                  prefillPostContent={prefillPostContent}
                  onPrefillPostHandled={() => setPrefillPostContent("")}
                />
              </div>
            </TabPane>
          )}

          {postsPermission?.view && (
            <TabPane tab={<span className="tab-label">📝 Posts</span>} key="2">
              <div className="tab-content">
                <ClientPostTabs dashboardView={postDashboardView} user={profile} />
              </div>
            </TabPane>
          )}

          {blogsPermission?.view && (
            <TabPane tab={<span className="tab-label">📁 Blogs</span>} key="7">
              <div className="tab-content">
                <ClientBlogTabs dashboardView={blogDashboardView} />
              </div>
            </TabPane>
          )}

          {writingAssistantPermission?.view && (
            <TabPane
              tab={<span className="tab-label">✍️ Writing Assistant</span>}
              key="8"
            >
              <div className="tab-content">
                <WritingAssistant
                  prefillTopic={prefillWritingTopic}
                  onPrefillHandled={() => setPrefillWritingTopic("")}
                  onSendForPost={(content) => {
                    setPrefillPostContent(content);
                    setActiveTab("1");
                  }}
                />
              </div>
            </TabPane>
          )}

          {contentThemesPermission?.view && (
            <TabPane
              tab={<span className="tab-label">🎯 Manage Content Themes</span>}
              key="3"
            >
              <div className="tab-content">
                <ManageContentTabs />
              </div>
            </TabPane>
          )}

          {vaultPermission?.view && (
            <TabPane tab={<span className="tab-label">📁 Vault</span>} key="4">
              <div className="tab-content">
                <VaultTabs />
              </div>
            </TabPane>
          )}

          {reportsPermission?.view && (
            <TabPane tab={<span className="tab-label">📊 Analytics</span>} key="5">
              <div className="tab-content">
                <ReportsTabs />
              </div>
            </TabPane>
          )}

          {reportsPermission?.view && (
            <TabPane tab={<span className="tab-label">📄 Milestone Report</span>} key="10">
              <div className="tab-content">
                <MonthlyReportTab />
              </div>
            </TabPane>
          )}

          {collaborationPermission?.view && (
            <TabPane
              tab={<span className="tab-label">💬 Research Assistant</span>}
              key="6"
            >
              <div className="tab-content">
                <CollaborationTabs onWrite={handleWrite} />
              </div>
            </TabPane>
          )}

          {notesPermission?.view && (
            <TabPane tab={<span className="tab-label">🗒️ Notes</span>} key="9">
              <div className="tab-content">
                <ManageNotesTabs />
              </div>
            </TabPane>
          )}

          {customerManagerPermission?.view && (
            <TabPane tab={<span className="tab-label">🧑‍💼 Assistants</span>} key="11">
              <AssistantsTab />
            </TabPane>
          )}
        </Tabs>
      </div>
      <ClientPreferenceModal
        visible={isModalOpen}
        onCancel={handleCloseModal}
        data={clientData}
        setRefresh={setRefresh}
      />
      <CreateNewPostIndex open={open} onClose={handleCloseDrawer} />
    </>
  );
};

export default ClientProfileView;
